<template>
    <tr class="study-requests__row">
        <td>
            <div class="study-requests__cell-number">
                <v-btn class="study-requests__expand-btn" flat icon
                       small @click="toggleExpandHandle"
                >
                    <v-icon v-if="!expanded">mdi-plus-circle-outline</v-icon>
                    <v-icon v-else>mdi-minus-circle-outline</v-icon>
                </v-btn>
                <span>{{ row.id }}</span>
            </div>
        </td>
        <td>{{ row.date_request }}</td>
        <td>{{ row.company }}</td>
        <td>{{ row.study_start }}</td>
        <td>
            <v-select
                v-if="accesses"
                :value="row.status"
                :items="statuses"
                class="study-request__row-select"
                item-text="label"
                item-value="value"
                full-width
                size="small"
                outline
                @change="selectStatusHandle"
            >
                <template #selection="{ item }">
                    <div class="v-select__selection v-select__selection--comma">
                        {{ $t(item.label) }}
                    </div>
                </template>
                <template #item="{ item }">
                    <img :src="`/icons/${statusIcons[item.value]}.svg`" alt="icon">
                    <span class="d-block ml-2 study-request__row-select-item font-weight-light">
                        {{ $t(item.label) }}
                    </span>
                </template>
            </v-select>
            <v-layout v-else>
                <img :src="`/icons/${statusIcons[currentStatus.value]}.svg`" alt="icon">
                <span class="d-block ml-2">{{ $t(currentStatus.label) }}</span>
            </v-layout>
        </td>
    </tr>
</template>

<script>
import {mapGetters} from 'vuex';
import planStatuses from '@/configs/plan_statuses';

export default {
  name : 'StudyPlanRequestRow',
  props: {
    row: {
      type    : Object,
      required: true,
    },
    expanded: {
      type   : Boolean,
      default: false,
    },
  },
  data: () => ({
    statusIcons: {
      [planStatuses.ACCEPT_REQUEST_STATUS]            : 'dots-circle-outline',
      [planStatuses.GRANTED_REQUEST_STATUS]           : 'check-circle',
      [planStatuses.GRANTED_MOVED_DATE_REQUEST_STATUS]: 'refresh-circle-outline',
      [planStatuses.CANCELLED_DATE_REQUEST_STATUS]    : 'close-circle',
    },
  }),
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('study_plan', ['get_request_statuses']),
    accesses() {
      if (this.user.role) {
        return !!this.user.role.managment_study_events.rights.length;
      }
      return false;
    },
    currentStatus() {
      return this.get_request_statuses.find((status) => +status.value === +this.row.status);
    },
    statuses() {
      if (+this.row.status === +planStatuses.CANCELLED_DATE_REQUEST_STATUS) {
        return this.get_request_statuses.filter(
            (status) => +status.value === +planStatuses.CANCELLED_DATE_REQUEST_STATUS
        );
      }
      return this.get_request_statuses;
    },
  },
  methods: {
    toggleExpandHandle() {
      this.$emit('click');
    },
    selectStatusHandle(status) {
      this.$store.dispatch('study_plan/update_request_status', {id: this.row.id, status});
    },
  },
};
</script>

<style lang="less">
@import url('../../../less/variables');
.study-request__row {
    &-select {
        &-item {
            font-size: 14px;
            line-height: 19px;
            font-weight: 300;
            font-family: @light-font;
        }
        &.v-text-field.v-text-field--enclosed .v-input__append-inner {
            margin-top: 12px;
            margin-right: 12px;
        }
    }
}
</style>
